import { AgentProtocol, AgentOutput } from './types';

export class TechnicalAgent implements AgentProtocol {
    role = 'Technical Analyst';

    async process(context: {
        opportunity: any;
        userStack: string;
        contractorName: string;
    }): Promise<AgentOutput> {
        const { opportunity, userStack, contractorName } = context;

        // Simplify for prototype: Use heuristics or a lightweight direct prompt
        // In full version, this would call a dedicated highly-specific prompt

        const prompt = `
            ROLE: Technical Implementation Specialist for ${contractorName}.
            TASK: Assess technical fit for a government contract.
            USER STACK: ${userStack}
            REQ TITLE: ${opportunity.title}
            REQ DESC: ${opportunity.description?.substring(0, 1500)}...
            
            Analyze:
            1. Does user have required tech stack? Be conservative.
            2. Match technical keywords in SOW to user capabilities.
            
            Output JSON: { "score": 0-100, "recommendation": "GO/NO-GO/REVIEW", "reasoning": "A short summary", "findings": ["Major Point 1", "Point 2"], "confidence": 0-1 }
        `;

        try {
            const { httpsCallable } = await import('firebase/functions');
            const { functions } = await import('../firebase');
            const analyzeOpportunity = httpsCallable(functions, 'analyzeOpportunity');

            const result = await analyzeOpportunity({
                prompt: prompt,
                context: opportunity
            });

            const data = result.data as any;
            const text = data.result || data.candidates?.[0]?.content?.parts?.[0]?.text || "{}";
            const json = JSON.parse(text.replace(/```json/g, '').replace(/```/g, '').trim());

            return {
                role: this.role,
                summary: json.reasoning || "Technical fit assessed.",
                score: json.score || 50,
                findings: json.findings || [],
                recommendation: json.recommendation || "REVIEW",
                confidence: json.confidence || 0.5,
                reasoning: json.reasoning || "Analysis complete."
            };
        } catch (e) {
            console.error("Technical Agent Error", e);
            return {
                role: this.role,
                summary: "Technical analysis failed.",
                score: 0,
                findings: ["System Error in LLM pipeline"],
                recommendation: "ERROR",
                confidence: 0,
                reasoning: "The technical agent encountered an internal error."
            };
        }
    }
}
